import React from 'react';

import {
  Breadcrumbs,
  BusinessContactForm,
  BusinessTariffsCard,
  InternetBanner,
  SearchTravel,
} from '@/ui/index';

import SpecialOffers from '../../roaming/SpecialOffers/SpecialOffers';
import { RoamingActivation } from '../../roaming';
import InternetActivation from '../../roaming/InternetActivation/InternetActivation';

const RoamingMain = ({ data }) => {
  return (
    <>
      {data?.breadcrumbs && <Breadcrumbs data={data.breadcrumbs} dark />}
      {data?.mainBanner && (
        <InternetBanner bannerData={data.mainBanner} dark medium />
      )}
      {data?.travel && <SearchTravel travelData={data.travel} />}
      {data?.offers && (
        <BusinessTariffsCard
          tabs={data.offers}
          title={'Recommended tariffs'}
          buttonText={'Archive'}
        />
      )}
      {data?.servicesList && <SpecialOffers data={data?.servicesList} />}
      {data?.productStatus && (
        <RoamingActivation productStatus={data?.productStatus} />
      )}
      {data?.internetActivation && (
        <InternetActivation data={data.internetActivation} />
      )}
      {data?.banner && <BusinessContactForm bannerData={data?.banner} />}
    </>
  );
};

export default RoamingMain;
